import { Flex, Text } from "onefaceui-react-components";
import React, { memo } from "react";
import PropTypes from 'prop-types';

import { renderTransportInfo } from "react/utils/utils";

const AdditionalMaterials = ({
  addMatArray,
  i18n
}) => {
  return (
    <div>
      <div className="qtySkuStrings">
        <div>{i18n.getResourcesByKey("route.data.quantity")}</div>
        <div>{i18n.getResourcesByKey("Sku")}</div>
      </div>
      <div id="materialGrid">
        {addMatArray.map((item) =>
          <React.Fragment key={`quantity_${item.id}`}>
            <div className="itemContainer">
              <div className="quantity">{item.quantity}</div>
              <Flex flexDirection="column" alignItems="center" gap={8}>
                <span className={`box ${item?.sizeAlias.icon}`} />
              </Flex>
            </div>
            <div className="skuContainer">
              <div className="skuKey">{item.sku.key}</div>
              <div className="transportInfos">
                <div>{item.sku.description}</div>
                {renderTransportInfo(item.transport)}
                <div className="boxQty">
                  <Flex
                    gap={2}
                    flexDirection="column"
                  >
                    <Flex gap={4} alignunits="center">
                      <Text size="xs" weight="bold">{item?.sizeAlias.preferredSize}</Text>
                      <Text size="xs">{item?.sizeAlias.description}</Text>
                    </Flex>
                  </Flex>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

AdditionalMaterials.propTypes = {
  addMatArray: PropTypes.array.isRequired,
  i18n: PropTypes.object.isRequired
};

export default memo(AdditionalMaterials);
